<template>
  <div :class="[`group-58-2`, className || ``]">
    <div class="rectangle-46-2"></div>
    <div class="rectangle-47-2"></div>
    <div class="rectangle-48-2"></div>
  </div>
</template>

<script>
export default {
  name: "Group58",
  props: ["className"],
};
</script>

<style>
.group-58-2 {
  display: flex;
  gap: 1.3px;
  height: 8px;
  left: 7px;
  position: absolute;
  top: 8px;
  width: 9px;
}

.rectangle-46-2 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 4.14px;
  margin-left: 0;
  margin-top: 4.1px;
  width: 2.01px;
}

.rectangle-47-2 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 6.21px;
  margin-top: 2.1px;
  width: 2.01px;
}

.rectangle-48-2 {
  background-color: var(--white);
  border-radius: 0.55px;
  height: 8.28px;
  margin-top: 0;
  width: 2.01px;
}

.group-58-2.group-58-3 {
  height: 9px;
  top: 9px;
}

.group-58-2.group-58-3 .rectangle-46-2 {
  border-radius: 0.67px;
  height: 4.71px;
  margin-top: 4.7px;
  width: 2.02px;
}

.group-58-2.group-58-3 .rectangle-47-2 {
  border-radius: 0.67px;
  height: 7.07px;
  margin-top: 2.4px;
  width: 2.02px;
}

.group-58-2.group-58-3 .rectangle-48-2 {
  border-radius: 0.67px;
  height: 9.43px;
  width: 2.02px;
}
</style>
